export default __webpack_public_path__ + "static/media/partner-logos.583d952b.png";